import React from 'react'

function TenderTextNDJ() {
  return (
    <embed src="\pdfs\EA2.3.2_nd-j_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextNDJ